module.exports = __webpack_public_path__ + "static/img/recharge-suc-img.b534fa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/recharge-suc-img.png
// module id = H+lM
// module chunks = 28